<template>
  <div class="py-3 grey lighten-4">
    <div class="px-2">
      <form class="p-3">
        <span>Enter your Cr email and password</span>

        <div class="input-field">
          <input id="email" type="email" class="validate" />
          <label for="email">Email</label>
        </div>

        <div class="input-field">
          <input id="password" type="password" class="validate" />
          <label for="password">Password</label>
        </div>

        <div>
          After enetering your credentials click "LOAD ADS" button to load your
          ads to the Ads Manager
        </div>
        <hr />
        <a @click="loadAds" class="waves-effect waves-light btn mt-2"
          >Load ads</a
        >
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showLogin: true
    };
  },
  methods: {
    loadAds() {
      this.$parent.closeFirst();
      this.$parent.loadAds();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue